(() => {
  if (window.sapHomeDetails) return;
  window.sapHomeDetails = true;
  const mounted = new WeakMap();
  const mount = (scope) =>
    scope.querySelectorAll("[data-detail-rail]").forEach((root) => {
      if (mounted.has(root)) return;
      const row = root.querySelector("[data-detail-row]");
      const buttons = [...root.querySelectorAll("[data-detail-step]")];
      const abort = new AbortController();
      const update = () => {
        const end = row.scrollWidth - row.clientWidth;
        root.classList.toggle("sap-detail-is-still", end <= 8);
        buttons.forEach((b) => {
          b.setAttribute("aria-disabled", String(b.dataset.detailStep === "prev" ? row.scrollLeft <= 8 : row.scrollLeft >= end - 8));
        });
      };
      buttons.forEach((button) =>
        button.addEventListener(
          "click",
          () => {
            if (button.getAttribute("aria-disabled") === "true") return;
            const gap = parseFloat(getComputedStyle(row).gap) || 0;
            const step = Math.max(
              (row.firstElementChild?.getBoundingClientRect().width || 0) + gap,
              row.clientWidth * 0.5,
            );
            row.scrollBy({
              left: (button.dataset.detailStep === "prev" ? -1 : 1) * step,
              behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            });
          },
          { signal: abort.signal },
        ),
      );
      row.addEventListener("scroll", update, { passive: true, signal: abort.signal });
      const resize = new ResizeObserver(update);
      resize.observe(row);
      mounted.set(root, () => {
        abort.abort();
        resize.disconnect();
        mounted.delete(root);
      });
      update();
    });
  mount(document);
  document.addEventListener("shopify:section:load", (e) => mount(e.target));
  document.addEventListener("shopify:section:unload", (e) =>
    e.target.querySelectorAll("[data-detail-rail]").forEach((root) => mounted.get(root)?.()),
  );
})();
